import React, { useEffect, useState } from "react";
import {
  Label,
  Dropdown,
  Input,
  Button,
  Switch,
  RadioGroup,
  Radio,
  Option,
  Field,

} from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import "../CSS/QueueForm.css";
import Language from "../GenericComponent/Language";
import InfoButton from "../GenericComponent/InfoButton";
import { WaitTimeSection } from "./MaxWaitTimeSection";
import HoldOnMusic from "./HoldOnMusicSection";
export default function QueueForm(props) {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!props.queue.queueName)
      newErrors.queueName = t("THIS_FIELD_IS_REQUIRED");
    if (!props.queue.scope) newErrors.scope = t("THIS_FIELD_IS_REQUIRED");

    setErrors(newErrors);

    // Retourne true si aucun champ vide
    const isValid = Object.keys(newErrors).length === 0;
    props.setFormValid(isValid); // on remonte l’état au parent
  };
  useEffect(() => {
    validateForm();
  }, [props.queue]);
  return (
    <div className="queue-form-root">
      <div className="queue-form-two-columns">
        {/* Colonne 1 */}
        <div className="queue-form-column">
          <div className="queue-form-group">
            <Field
              weight="semibold"
              label={t("QUEUE_NAME")}
              className="queue-form-field"
              required
              validationState={errors.queueName ? "error" : "none"}
              validationMessage={errors.queueName}
            >
              <Input
                className="queue-form-input-inline"
                placeholder={t("ENTER_QUEUE_NAME")}
                value={props.queue?.queueName}
                disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                onChange={(event, data) => {
                  props.setQueue({
                    ...props.queue,
                    queueName: data.value,
                  });
                }}
              />
            </Field>
          </div>

      <Field label={t("LANGUAGE")}
        className="queue-form-field">
        <Language
          language={props.queue?.language}
          setLangue={(newLang) => {
            props.setQueue({
              ...props.queue,
              language: newLang,
            });
          }}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
        />
      </Field>
      <Field label={t("MUSIC_ON_HOLD")} className="queue-form-field">
        <HoldOnMusic
          medias={props.medias}
          defaultMusic={props.queue?.musicOnHold?.[0]}
          queue={props.queue}
          setQueue={props.setQueue}
          permissions={props.permissions}
          isUpdate={props.isUpdate}
        />
      </Field>

      <Field label={t("MAX_WAIT_TIME_SECONDS")}
        className="queue-form-field">
        <Input
          type="number"
          placeholder={t("SECONDS_PLACEHOLDER")}
          min={0}
          value={props.queue?.maxWaitTime}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              maxWaitTime: data.value,
            });
          }}
          className="queue-form-input-inline"
        />
      </Field>

      <Field label={t("MAX_CALLS_IN_QUEUE")}
        className="queue-form-field">
        <Input
          type="number"
          placeholder={t("MAX_CALL_IN_QUEUE_PLACEHOLDER")}

          min={0}
          value={props.queue?.maxInQueue}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              maxInQueue: data.value,
            });
          }}
          className="queue-form-input-inline"
        />
      </Field>

      <Field
        label={
          <>
            {t("MAX_AGENT_ALERT_TIME_SECONDS")}
            <InfoButton infoKey="MAX_AGENT_ALERT_TIME_SECONDS" category="QUEUES" />
          </>
        }

        className="queue-form-field"
      >
        <Input
          type="number"
          placeholder={t("SECONDS_PLACEHOLDER")}
          min={0}
          value={props.queue?.maxAlertTime}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              maxAlertTime: data.value,
            });
          }}
          className="queue-form-input-inline"
        />
      </Field>
      <Field label={
        <>
          {t("WRAP_UP_TIME_SECONDS")}
          <InfoButton infoKey="WRAP_UP_TIME_SECONDS" category="QUEUES" />
        </>
      }
        className="queue-form-field">
        <Input
          type="number"
          placeholder={t("SECONDS_PLACEHOLDER")}
          min={0}
          value={props.queue?.wrapUpTime}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(event, data) => {
            props.setQueue({
              ...props.queue,
              wrapUpTime: data.value,
            });
          }}
          className="queue-form-input-inline"
        />
      </Field>

      {/* Options déplacées sous le wrap-up */}
      <div className="queue-form-checkbox">
        <Label weight="semibold">
          {t("KEEP_AGENT_ON_REQUEUE")}
          <InfoButton infoKey="KEEP_AGENT_ON_REQUEUE" category="QUEUES" />
        </Label>
        <Switch
          checked={props.queue?.keepAgentOnRequeue || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              keepAgentOnRequeue: data.checked,
            });
          }}
        />
      </div>

      <div className="queue-form-checkbox">
        <Label weight="semibold">
          {t("ANNOUNCE_POSITION_IN_QUEUE")}
          <InfoButton infoKey="ANNOUNCE_POSITION_IN_QUEUE" category="QUEUES" />
        </Label>
        <Switch
          checked={props.queue?.announcePositionInQueue || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              announcePositionInQueue: data.checked,
            });
          }}
        />
      </div>

      <div className="queue-form-checkbox">
        <Label weight="semibold">
          {t("ANNOUNCE_ESTIMATED_WAIT_TIME")}
          <InfoButton infoKey="ANNOUNCE_ESTIMATED_WAIT_TIME" category="QUEUES" />
        </Label>
        <Switch
          checked={props.queue?.announceEstimatedWaitTime || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              announceEstimatedWaitTime: data.checked,
            });
          }}
        />
      </div>

      {/* Wait time list — regroupé avec "Announce estimated wait time" */}
      <WaitTimeSection
        queue={props.queue}
        onWaitTimesChange={(newWaitTimes) => {
          props.setQueue({ ...props.queue, waitTimeIntervals: newWaitTimes });
        }}
        permissions={props.permissions}
        isUpdate={props.isUpdate}
      />
        </div>

        {/* Colonne 2 - Scope et Type */}
        <div className="queue-form-column">
          <div className="queue-form-group">
            <Label weight="semibold" required>{t("SCOPE")}</Label>
            <Field
              className="queue-form-field"
              validationState={errors.scope ? "error" : "none"}
              validationMessage={errors.scope}
            >
              <Dropdown
                clearable
                className="queue-form-input-inline"
                placeholder={t("SELECT_SCOPE")}
                value={props.queue.scope}
                disabled={props.isUpdate === true}
                onOptionSelect={(_, data) => {
                  props.setQueue((queue) => ({
                    ...queue,
                    scope: data.optionValue,
                  }));
                }}
              >
                {props.scopes.map((scope, index) => (
                  <Option key={index} value={scope}>
                    {scope}
                  </Option>
                ))}
              </Dropdown>
            </Field>
          </div>

          <div className="queue-form-group">
            <Label weight="semibold" required>{t("TYPE_QUEUE")}</Label>
           
            <div className="queue-form-chat-disv">
              {/* Chat Switch */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '100%' , justifyContent: "space-between"}}>
                <label>{t("CHAT")}</label>
                <Switch
                  checked={props.queue.channels?.chat || false}
                  disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                  onChange={(_, data) => {
                    props.setQueue((queue) => ({
                      ...queue,
                      channels: {
                        ...queue.channels,
                        chat: data.checked,
                      },
                    }));
                  }}
                />
              </div>

              {/* Call Switch */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '100%', justifyContent: "space-between" }}>
                <label>{t("CALL")}</label>
                <Switch
                  checked={props.queue.channels?.call || false}
                  disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                  onChange={(_, data) => {
                    props.setQueue((queue) => ({
                      ...queue,
                      channels: {
                        ...queue.channels,
                        call: data.checked,
                      },
                    }));
                  }}
                />
              </div>

              {/* Mail Switch — c'est CE drapeau que la file lit pour accepter un mail.
                  Sans lui, `onNewMail` répond 409 MAIL_CHANNEL_DISABLED : le mail reste en
                  base, rattrapable, mais aucun agent ne le voit. Il n'était jusqu'ici
                  positionnable qu'en écrivant directement dans Cosmos. */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: '100%', justifyContent: "space-between" }}>
                <label>{t("MAIL")}</label>
                <Switch
                  checked={props.queue.channels?.mail || false}
                  disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                  onChange={(_, data) => {
                    props.setQueue((queue) => ({
                      ...queue,
                      channels: {
                        ...queue.channels,
                        mail: data.checked,
                      },
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
